export default __webpack_public_path__ + "static/awarepath_small-image_1-21738f89ed46e4fa8efa30fcab76c049.png";